import * as formulas from "../operations/show_formulas";

export function showFormulas(state, page){
	formulas.showFormulas(this, state, page);
}